import { render, staticRenderFns } from "./expert-review.vue?vue&type=template&id=5dcef6d4&scoped=true"
import script from "./expert-review.vue?vue&type=script&lang=js"
export * from "./expert-review.vue?vue&type=script&lang=js"
import style0 from "./expert-review.vue?vue&type=style&index=0&id=5dcef6d4&prod&lang=scss&scoped=true"
import style1 from "./expert-review.vue?vue&type=style&index=1&id=5dcef6d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcef6d4",
  null
  
)

export default component.exports